'use strict';

(function() {
    const stepsContainer = document.getElementById('stepsContainer');
    if (!stepsContainer) return;

    const progressFill = document.getElementById('progressFill');
    const TOTAL_STEPS = 6;
    const state = {
        currentStep: 1,
        answers: {
            propertyTypes: [],
            debtTypes: []
        }
    };

    function getStepEl(n) {
        return stepsContainer.querySelector(`[data-step="${n}"]`);
    }

    function updateProgress() {
        if (!progressFill) return;
        const pct = Math.round((state.currentStep / TOTAL_STEPS) * 100);
        progressFill.style.width = `${Math.min(pct, 100)}%`;
    }

    function isStepValid(step) {
        const stepEl = getStepEl(step);
        if (!stepEl) return false;

        if (step === 6) {
            const name = document.getElementById('contactName')?.value.trim() || '';
            const phone = document.getElementById('contactPhone')?.value.trim() || '';
            const privacy = document.getElementById('privacyCheck')?.checked || false;
            const messenger = state.answers.messenger !== null && state.answers.messenger !== undefined;

            const digits = phone.replace(/\D/g, '');
            const isPhoneValid = validatePhone(digits);

            return name !== '' && isPhoneValid && privacy && messenger;
        }

        if (step === 2) {
            const checked = stepEl.querySelectorAll('input[type="checkbox"]:checked');
            return checked.length > 0;
        }

        if (step === 3) {
            const checked = stepEl.querySelectorAll('input[type="checkbox"]:checked');
            return checked.length > 0;
        }

        const selectedItem = stepEl.querySelector('.selected');
        if (selectedItem) return true;

        const checkedRadio = stepEl.querySelector('input[type="radio"]:checked');
        if (checkedRadio) return true;

        return false;
    }

    function validatePhone(phone) {
        const digits = phone.replace(/\D/g, '');
        if (digits.length === 11 && digits.startsWith('7')) {
            return true;
        }
        if (digits.length === 10) {
            return true;
        }
        return false;
    }

    function formatPhone(phone) {
        let digits = phone.replace(/\D/g, '');

        if (digits.startsWith('8')) {
            digits = '7' + digits.slice(1);
        }

        if (digits.length === 11 && digits.startsWith('7')) {
            return '+7 ' + digits.slice(1, 4) + ' ' + digits.slice(4, 7) + '-' + digits.slice(7, 9) + '-' + digits.slice(9, 11);
        }

        if (digits.length === 10) {
            return '+7 ' + digits.slice(0, 3) + ' ' + digits.slice(3, 6) + '-' + digits.slice(6, 8) + '-' + digits.slice(8, 10);
        }

        if (digits.startsWith('7') && digits.length > 1) {
            return '+7 ' + digits.slice(1);
        }

        return '+7 ' + digits;
    }

    // ============================================================
    // ОБРАБОТКА ПОЛЯ ТЕЛЕФОНА
    // ============================================================
    const phoneInput = document.getElementById('contactPhone');
    if (phoneInput) {
        phoneInput.addEventListener('focus', function() {
            const val = this.value.trim();
            if (val === '' || val === '+7') {
                this.value = '+7 ';
                const range = this.value.length;
                this.setSelectionRange(range, range);
            }
        });

        phoneInput.addEventListener('input', function() {
            let val = this.value;

            if (val === '') {
                return;
            }

            let digits = val.replace(/[^\d+]/g, '');

            if (digits.startsWith('+')) {
                digits = '+' + digits.replace(/\+/g, '');
            }

            const cleanDigits = digits.replace(/\D/g, '');

            if (cleanDigits.length === 1 && (cleanDigits === '8' || cleanDigits === '7')) {
                this.value = '+7 ';
                const range = this.value.length;
                this.setSelectionRange(range, range);
                return;
            }

            if (cleanDigits.length === 10 && !val.includes('+')) {
                this.value = formatPhone(cleanDigits);
                const range = this.value.length;
                this.setSelectionRange(range, range);
                return;
            }

            if (cleanDigits.length === 11 && (cleanDigits.startsWith('7') || cleanDigits.startsWith('8'))) {
                let formatted = cleanDigits;
                if (formatted.startsWith('8')) {
                    formatted = '7' + formatted.slice(1);
                }
                this.value = formatPhone(formatted);
                const range = this.value.length;
                this.setSelectionRange(range, range);
                return;
            }

            if (digits.length > 12) {
                digits = digits.slice(0, 12);
            }

            if (digits.startsWith('+')) {
                this.value = digits;
            } else {
                const onlyDigits = digits.replace(/\D/g, '');
                if (onlyDigits.length > 0) {
                    if (onlyDigits.startsWith('8') || onlyDigits.startsWith('7')) {
                        this.value = '+7 ' + onlyDigits.slice(1);
                    } else {
                        this.value = '+7 ' + onlyDigits;
                    }
                } else {
                    this.value = digits;
                }
            }

            const phoneDigits = this.value.replace(/\D/g, '');
            if (phoneDigits.length > 0 && phoneDigits.length < 10) {
                this.style.borderColor = '#f44336';
            } else if (validatePhone(phoneDigits)) {
                this.style.borderColor = '#4CAF50';
            } else {
                this.style.borderColor = '';
            }
        });

        phoneInput.addEventListener('blur', function() {
            let val = this.value.trim();

            if (val === '' || val === '+7' || val === '+7 ') {
                this.value = '';
                this.style.borderColor = '';
                return;
            }

            const digits = val.replace(/\D/g, '');

            if (validatePhone(digits)) {
                this.value = formatPhone(digits);
                this.style.borderColor = '#4CAF50';
            } else if (digits.length > 0) {
                this.style.borderColor = '#f44336';
            } else {
                this.style.borderColor = '';
            }
        });
    }

    function showStepError(step) {
        const stepEl = getStepEl(step);
        if (!stepEl) return;

        const oldError = stepEl.querySelector('.step-error');
        if (oldError) oldError.remove();

        const errorDiv = document.createElement('div');
        errorDiv.className = 'step-error';

        if (step === 2) {
            errorDiv.innerText = 'Пожалуйста, выберите хотя бы один вариант имущества';
        } else if (step === 3) {
            errorDiv.innerText = 'Пожалуйста, выберите хотя бы один вид задолженности';
        } else if (step === 6) {
            const phone = document.getElementById('contactPhone')?.value.trim() || '';
            const digits = phone.replace(/\D/g, '');
            const isPhoneValid = validatePhone(digits);

            if (!isPhoneValid && phone !== '') {
                errorDiv.innerText = 'Введите корректный номер телефона (10 или 11 цифр)';
            } else {
                errorDiv.innerText = 'Пожалуйста, заполните все поля и подтвердите согласие';
            }
        } else {
            errorDiv.innerText = 'Пожалуйста, выберите вариант перед продолжением';
        }

        const navButtons = stepEl.querySelector('.step-nav');
        if (navButtons) {
            navButtons.parentNode.insertBefore(errorDiv, navButtons);
        } else {
            stepEl.appendChild(errorDiv);
        }

        setTimeout(() => {
            if (errorDiv.parentNode) errorDiv.remove();
        }, 3000);
    }

    function showStep(n) {
        stepsContainer.querySelectorAll('.step-error').forEach(err => err.remove());

        stepsContainer.querySelectorAll('.step').forEach(el => el.classList.add('hidden'));

        const target = getStepEl(n);
        if (target) {
            target.classList.remove('hidden');
            target.style.animation = 'none';
            void target.offsetWidth;
            target.style.animation = '';
        }

        updateProgress();

        if (n === 6) {
            if (!state.answers.messenger) {
                const firstBtn = document.querySelector('.messenger-btn');
                if (firstBtn) {
                    state.answers.messenger = firstBtn.dataset.messenger;
                    firstBtn.classList.add('messenger-btn--active');
                }
            } else {
                document.querySelectorAll('.messenger-btn').forEach(btn => {
                    if (btn.dataset.messenger === state.answers.messenger) {
                        btn.classList.add('messenger-btn--active');
                    } else {
                        btn.classList.remove('messenger-btn--active');
                    }
                });
            }
        }
    }

    function resetQuiz() {
        state.answers = { propertyTypes: [], debtTypes: [] };
        state.currentStep = 1;

        stepsContainer.querySelectorAll('.list-option.selected')
            .forEach(el => el.classList.remove('selected'));

        stepsContainer.querySelectorAll('input[type="radio"], input[type="checkbox"]')
            .forEach(inp => { inp.checked = false; });

        const nameField = document.getElementById('contactName');
        const phoneField = document.getElementById('contactPhone');
        if (nameField) nameField.value = '';
        if (phoneField) {
            phoneField.value = '';
            phoneField.style.borderColor = '';
        }

        const privacyCheck = document.getElementById('privacyCheck');
        if (privacyCheck) privacyCheck.checked = false;

        document.querySelectorAll('.messenger-btn--active')
            .forEach(btn => btn.classList.remove('messenger-btn--active'));
        state.answers.messenger = null;

        if (progressFill) {
            progressFill.style.transition = 'none';
            progressFill.style.width = '14%';
            requestAnimationFrame(() => {
                if (progressFill) progressFill.style.transition = '';
            });
        }

        stepsContainer.querySelectorAll('.step-error').forEach(err => err.remove());

        showStep(1);
    }

    function applySelectionToList(label) {
        const group = label.dataset.name;
        const input = label.querySelector('input');

        if (input && input.type === 'checkbox') {
            input.checked = !input.checked;

            if (input.checked) {
                label.classList.add('selected');
                if (group === 'propertyTypes') {
                    if (!state.answers.propertyTypes.includes(label.dataset.value)) {
                        state.answers.propertyTypes.push(label.dataset.value);
                    }
                } else if (group === 'debtTypes') {
                    if (!state.answers.debtTypes.includes(label.dataset.value)) {
                        state.answers.debtTypes.push(label.dataset.value);
                    }
                }
            } else {
                label.classList.remove('selected');
                if (group === 'propertyTypes') {
                    state.answers.propertyTypes = state.answers.propertyTypes.filter(
                        v => v !== label.dataset.value
                    );
                } else if (group === 'debtTypes') {
                    state.answers.debtTypes = state.answers.debtTypes.filter(
                        v => v !== label.dataset.value
                    );
                }
            }

            const stepEl = getStepEl(state.currentStep);
            if (stepEl) {
                const error = stepEl.querySelector('.step-error');
                const hasSelection = state.answers.propertyTypes.length > 0 || state.answers.debtTypes.length > 0;
                if (error && hasSelection) error.remove();
            }
            return;
        }

        if (input) input.checked = true;

        stepsContainer.querySelectorAll(`.list-option[data-name="${group}"]`)
            .forEach(el => el.classList.remove('selected'));

        label.classList.add('selected');
        state.answers[group] = label.dataset.value;

        const stepEl = getStepEl(state.currentStep);
        if (stepEl) {
            const error = stepEl.querySelector('.step-error');
            if (error) error.remove();
        }
    }

    function goNext() {
        if (state.currentStep < TOTAL_STEPS) {
            if (!isStepValid(state.currentStep)) {
                showStepError(state.currentStep);
                return;
            }
            state.currentStep += 1;
            showStep(state.currentStep);
        }
    }

    function goBack() {
        if (state.currentStep > 1) {
            state.currentStep -= 1;
            showStep(state.currentStep);
        }
    }

    function handleMessenger(btn) {
        const selected = btn.dataset.messenger;
        state.answers.messenger = selected;

        document.querySelectorAll('.messenger-btn').forEach(b => {
            if (b.dataset.messenger === selected) {
                b.classList.add('messenger-btn--active');
            } else {
                b.classList.remove('messenger-btn--active');
            }
        });

        if (state.currentStep === 6 && isStepValid(6)) {
            const stepEl = getStepEl(6);
            if (stepEl) {
                const error = stepEl.querySelector('.step-error');
                if (error) error.remove();
            }
        }
    }

    // ============================================================
    // ОТПРАВКА ФОРМЫ
    // ============================================================
    function handleSubmit() {
        if (!isStepValid(6)) {
            showStepError(6);
            return;
        }

        const nameEl = document.getElementById('contactName');
        const phoneEl = document.getElementById('contactPhone');
        const privacyCheck = document.getElementById('privacyCheck');

        const name = nameEl ? nameEl.value.trim() : '';
        let phone = phoneEl ? phoneEl.value.trim() : '';
        const digits = phone.replace(/\D/g, '');

        if (!name) {
            alert('Введите имя');
            nameEl?.focus();
            return;
        }
        if (!validatePhone(digits)) {
            alert('Введите корректный номер телефона (10 или 11 цифр)');
            phoneEl?.focus();
            return;
        }
        if (!privacyCheck || !privacyCheck.checked) {
            alert('Подтвердите согласие');
            privacyCheck?.focus();
            return;
        }

        phone = formatPhone(digits);

        const submitBtn = document.getElementById('submitBtn');
        if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.textContent = 'Отправка...';
        }

        // Собираем данные
        const formData = new FormData();
        formData.append('action', 'zarechye_submit_quiz');
        formData.append('nonce', takt_ajax.nonce);
        formData.append('name', name);
        formData.append('phone', phone);
        formData.append('messenger', state.answers.messenger || '');
        formData.append('debtAmount', state.answers.debtAmount || '');
        formData.append('overdue', state.answers.overdue || '');
        formData.append('collateral', state.answers.collateral || '');
        formData.append('timestamp', new Date().toISOString());

        // Массивы
        state.answers.propertyTypes.forEach(function(val) {
            formData.append('propertyTypes[]', val);
        });

        state.answers.debtTypes.forEach(function(val) {
            formData.append('debtTypes[]', val);
        });

        // Отправка AJAX
        fetch(takt_ajax.ajax_url, {
            method: 'POST',
            body: formData
        })
        .then(function(response) {
            return response.json();
        })
        .then(function(data) {
            if (data.success) {
                window.location.href = '/quiz-thanks/';
            } else {
                alert(data.data || 'Произошла ошибка. Попробуйте ещё раз.');
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.textContent = 'Получить консультацию';
                }
            }
        })
        .catch(function(error) {
            console.error('Ошибка:', error);
            alert('Произошла ошибка. Попробуйте ещё раз.');
            if (submitBtn) {
                submitBtn.disabled = false;
                submitBtn.textContent = 'Получить консультацию';
            }
        });
    }

    // ============================================================
    // СОБЫТИЯ
    // ============================================================

    stepsContainer.addEventListener('click', function(e) {
        const list = e.target.closest('.list-option');
        if (list) {
            applySelectionToList(list);
            return;
        }

        const navBtn = e.target.closest('[data-action]');
        if (navBtn) {
            const action = navBtn.dataset.action;
            if (action === 'next') goNext();
            if (action === 'back') goBack();
            if (action === 'restart') resetQuiz();
            return;
        }

        if (e.target.closest('#submitBtn')) {
            handleSubmit();
        }
    });

    document.addEventListener('click', function(e) {
        const messengerBtn = e.target.closest('.messenger-btn');
        if (messengerBtn) handleMessenger(messengerBtn);
    });

    const nameInput = document.getElementById('contactName');
    const privacyCheckbox = document.getElementById('privacyCheck');

    const clearErrorOnStep = function() {
        const currentStep = state.currentStep;
        if (currentStep === 6 && isStepValid(6)) {
            const stepEl = getStepEl(6);
            if (stepEl) {
                const error = stepEl.querySelector('.step-error');
                if (error) error.remove();
            }
        }
    };

    if (nameInput) nameInput.addEventListener('input', clearErrorOnStep);
    if (privacyCheckbox) privacyCheckbox.addEventListener('change', clearErrorOnStep);

    stepsContainer.addEventListener('change', function(e) {
        if (e.target.type === 'checkbox') {
            const stepEl = getStepEl(state.currentStep);
            if (stepEl && (state.currentStep === 2 || state.currentStep === 3)) {
                const error = stepEl.querySelector('.step-error');
                if (error) {
                    const checked = stepEl.querySelectorAll('input[type="checkbox"]:checked');
                    if (checked.length > 0) error.remove();
                }
            }
        }
    });

    showStep(1);

})();
